export const NOT_EXIST_ADDRESS_ERROR = "NOT_EXIST_ADDRESS_ERROR";
export const INVALID_USER_TYPE_OFFICER = "INVALID_USER_TYPE_OFFICER";
export const INVALID_USER_TYPE_WORKER = "INVALID_USER_TYPE_WORKER";
export const AUTH_ERROR = "AUTH_ERROR";
export const UPDATE_ERROR = "UPDATE_ERROR";
export const OTHER_DEVICE_LOGIN_ERROR = "OTHER_DEVICE_LOGIN_ERROR";
